// Production build'de tarayici konsoluna log basilmasin (kullanici/calisan bilgileri, i18next uyarilari vb.).
// console.error dahil tum console metotlari kapatilir.
// index.tsx'te ilk import olmali ki diger moduller yuklenirken basilan loglar da susturulsun.
if (process.env.NODE_ENV === 'production') {
  const noop = () => {}
  const methods = ['log', 'error', 'info', 'debug', 'warn', 'trace', 'table', 'dir', 'dirxml', 'group', 'groupCollapsed', 'groupEnd', 'time', 'timeEnd', 'timeLog', 'count', 'countReset', 'assert'] as const
  const consoleMethods = console as unknown as Record<string, () => void>
  methods.forEach((method) => {
    consoleMethods[method] = noop
  })
}

export {}
